




import type { Ref } from '@vue/composition-api';
import { defineComponent, onMounted, computed, ref } from '@vue/composition-api';
import lottie from 'lottie-web';

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const lavContainer: Ref<HTMLInputElement> = ref(null);

    const jsonLoader = computed(() => {
      let jsonData = '';
      try {
        jsonData = require(`../assets/lottie/${props.name}.json`);
      } catch (e) {
        console.error(e);
      }
      return jsonData;
    });

    onMounted(() => {
      const animationContainer: HTMLInputElement = lavContainer.value;
      const lottieAnimation: any = lottie.loadAnimation({
        container: animationContainer,
        renderer: 'svg',
        loop: props.loop,
        autoplay: props.autoplay,
        animationData: jsonLoader.value,
      });
      emit('created', lottieAnimation);
    });

    return {
      jsonLoader,
      lavContainer,
    };
  },
});
